export const GAME_STYLES = {
  CLASSIC: 'Classic',
  CHAINED_MODE: 'Chained challenges',
  TIME_ATTACK: 'Time attack',
  ESCAPE_ROOM: 'Escape Room',
  GOOSE_GAME: 'Snakes and Ladders',
  CATCH_THE_FLAG: 'Catch the flag',
  CHOOSE_YOUR_OWN_HUNT: 'Choose your own hunt',
  THE_FUGITIVE: 'The fugitive',
}

export function disabledGameStyles(style) {
  return style !== GAME_STYLES.CLASSIC && style !== GAME_STYLES.CHAINED_MODE && style !== GAME_STYLES.TIME_ATTACK
}

export function isThereAnIconForGameStyle(style) {
  if (style === GAME_STYLES.CHAINED_MODE) {
    return 'link-variant'
  }
  if (style === GAME_STYLES.TIME_ATTACK) {
    return 'clock-fast'
  }
  return 'map-marker-circle'
}

export default {
  GAME_STYLES,
  disabledGameStyles,
  isThereAnIconForGameStyle
}
